var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullScreen"},[_c('div',{staticClass:"fullScreen-item"},[_c(_vm.getComponents,{tag:"component",attrs:{"fullStatus":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }